// extracted by mini-css-extract-plugin
module.exports = {"cardHolder":"AllStudents_cardHolder__1aSkl"};